export default "__VITE_ASSET__dO5NBO0g__"